<template>
  <div class="merchant-container">
    <div class="side-nav">
      <MerchantSideNav />
      <MenuToggle />
    </div>
    <div class="merchant-body transaction-body">
      <header>
        <MerchantHeader />
      </header>
      <div class="dashboard-content">
        <div class="row mt-5">
          <h3>Transactions Details</h3>
        </div>
        <div class="row">
          <div class="col-12 pl-0">
            <div class="card-style">
              <div class="grid-layout">
                <div class="right-side">
                  <span>Organization Name</span>
                  <span>Date & Time</span>
                  <span>Method</span>
                  <span>Country</span>
                  <span>Status</span>
                  <span>Description</span>
                </div>
                <div class="right-side">
                  <h4>StayorFly</h4>
                  <h4>24 Aug 2020 02:32 PM</h4>
                  <h4>Master Card</h4>
                  <h4>Nepal</h4>
                  <h4>Complete</h4>
                  <h4>Lorem ipsum Lorem ipsum Lorem ipsumLorem ipsum Lorem</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <MerchantFooter />
    </footer>
  </div>
</template>
<script>
import MerchantHeader from "./MerchantHeader.vue";
import MerchantFooter from "./MerchantFooter.vue";
import MerchantSideNav from "./MerchantSideNav.vue";
import MenuToggle from "./MenuToggle.vue";

export default {
  components: {
    MerchantHeader,
    MerchantFooter,
    MerchantSideNav,
    MenuToggle
  },
};
</script>
<style lang="scss" scoped>
</style>